import { checkEnvironment } from '@saviynt/common';

const generateSshTokenUrl = (sessionKey) => {
  const { GATEWAY_API_URL } = checkEnvironment();

  return `${GATEWAY_API_URL}/api/pam-ssh-proxy/sessions/${sessionKey}/auth`;
};

export default generateSshTokenUrl;
